function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, useContext, useImperativeHandle } from "react";
import classnames from "classnames";
import { mergeProps } from "../../utils/mergeProps";
import { usePropsValue } from "../../utils/use-props-value";
import { withNativeProps } from "../../utils/with-native-props";
import { CheckboxGroupContext } from "./group-context";
import { NativeInput } from "./native-input";
import { CheckedFillIcon, CorrectIcon, RoundIcon } from "@t8891/icon";
var defaultProps = {
  defaultChecked: false,
  indeterminate: false,
  type: "square"
};
var classPrefix = "tc-checkbox";
export var Checkbox = /*#__PURE__*/forwardRef(function (p, ref) {
  var _classnames;
  var props = mergeProps(defaultProps, p);
  var groupContext = useContext(CheckboxGroupContext);
  var defaultChecked = props.defaultChecked,
    onChange = props.onChange,
    value = props.value,
    icon = props.icon,
    indeterminate = props.indeterminate,
    block = props.block,
    id = props.id,
    children = props.children,
    className = props.className,
    style = props.style,
    type = props.type,
    _props$strokeWidth = props.strokeWidth,
    strokeWidth = _props$strokeWidth === void 0 ? 2 : _props$strokeWidth;
  var disabled = props.disabled;
  var _usePropsValue = usePropsValue({
      value: props.checked,
      defaultValue: defaultChecked,
      onChange: onChange
    }),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    checked = _usePropsValue2[0],
    setChecked = _usePropsValue2[1];
  if (groupContext && value !== undefined) {
    checked = groupContext === null || groupContext === void 0 ? void 0 : groupContext.value.includes(value);
    setChecked = function setChecked(check) {
      if (check) {
        groupContext.check(value);
      } else {
        groupContext.unCheck(value);
      }
      onChange === null || onChange === void 0 ? void 0 : onChange(check);
    };
    disabled = disabled || groupContext.disabled;
  }
  useImperativeHandle(ref, function () {
    return {
      check: function check() {
        setChecked(true);
      },
      uncheck: function uncheck() {
        setChecked(false);
      },
      toggle: function toggle() {
        setChecked(!checked);
      }
    };
  });
  var renderIcon = function renderIcon() {
    if (icon) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "-custom-icon")
      }, icon(checked, indeterminate));
    }
    if (type === "square") {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "-icon")
      }, indeterminate ? /*#__PURE__*/React.createElement(CorrectIcon, {
        size: 32,
        fill: '#FFF',
        strokeWidth: strokeWidth
      }) : checked && /*#__PURE__*/React.createElement(CorrectIcon, {
        size: 32,
        fill: '#FFF',
        strokeWidth: strokeWidth
      }));
    }
    var fillColor = disabled ? "#EEE" : "var(--tc-color-base)";
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-icon-round")
    }, checked ? /*#__PURE__*/React.createElement(CheckedFillIcon, {
      size: 32,
      fill: fillColor
    }) : /*#__PURE__*/React.createElement(RoundIcon, {
      size: 32,
      fill: fillColor
    }));
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("label", {
    className: classnames(classPrefix, (_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "-checked"), checked && !indeterminate), _defineProperty(_classnames, "".concat(classPrefix, "-indeterminate"), indeterminate), _defineProperty(_classnames, "".concat(classPrefix, "-disabled"), disabled), _defineProperty(_classnames, "".concat(classPrefix, "-block"), block), _defineProperty(_classnames, "className", className), _classnames)),
    style: style
  }, /*#__PURE__*/React.createElement(NativeInput, {
    type: 'checkbox',
    checked: checked,
    onChange: setChecked,
    disabled: disabled,
    id: id
  }), renderIcon(), !!children && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, children)));
});